
















































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseButton from '@/ui/BaseButton.vue';
import TheTableStaff from '@/components/staff/TheTableStaff.vue';
// Importing function
import {getStaff} from '@/ts/staff/get-staff';

export default {
    name: 'PageUsers',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableStaff,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getStaff(this.$route.params.id).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        onSubmit() {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setQueryParam', this.search_param);
            getStaff(this.$route.params.id).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Служители',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getStaff(this.$route.params.id).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
